<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="计划执行日期">
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
                date-format="YYYY-MM-DD"
              ></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="任务状态">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="dev_maintaince_task_status"
                placeholder="请选择"
                type="checkbox"
                v-model="queryParam.taskStatus"
              ></j-multi-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div :style="{ justifyContent: pageTypeEumList ? 'space-between' : 'flex-end' }" class="flex justify-between">
      <div class="table-operator" v-if="pageTypeEumList">
        <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
        <a-button @click="handleExportXls('保养任务/记录')" icon="download" type="primary">导出</a-button>
        <a-upload
          :action="importExcelUrl"
          :headers="tokenHeader"
          :multiple="false"
          :showUploadList="false"
          @change="handleImportExcel"
          name="file"
        ></a-upload>

        <!-- 高级查询区域 -->
        <j-super-query
          :fieldList="superFieldList"
          @handleSuperQuery="handleSuperQuery"
          ref="superQueryModal"
        ></j-super-query>
      </div>
      <a-button-group>
        <a-button :type="pageType === 'list' ? 'primary' : 'default'" @click="triggerBtn('list')">列表</a-button>
        <a-button :type="pageType === 'calendar' ? 'primary' : 'default'" @click="triggerBtn('calendar')"
          >日历</a-button
        >
      </a-button-group>
    </div>

    <!-- table区域-begin -->
    <div v-if="pageTypeEumList">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="device" slot-scope="text, record">
          <link-to-detail
            :id="text"
            :text="record.devName"
            pageType="drawer"
            route-name="FusionDevice"
          ></link-to-detail>
        </template>
        <template slot="finishId" slot-scope="text, record">
          <link-to-detail
            :id="text"
            :text="record.finishId_dictText"
            pageType="drawer"
            route-name="FusionPerson"
          ></link-to-detail>
        </template>
        <template slot="status" slot-scope="text">
          <a-tag :color="filterStatus(text)">{{ $filterDictTextByCache('dev_maintaince_task_status', text) }}</a-tag>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
            >下载</a-button
          >
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDefer(record)">延期</a>
          <a-divider type="vertical" />

          <a @click="handleRecord(record)">{{ record.taskStatus == 2 ? '查看' : '记录' }}</a>
        </span>
      </a-table>
    </div>
    <maintaince-plan-calendar v-else />

    <dev-maintaince-task-modal @ok="modalFormOk" ref="modalForm"></dev-maintaince-task-modal>
    <task-device-modal :canEdit="canEdit" @ok="modalFormOk" ref="taskDevice"></task-device-modal>
    <defer-modal @ok="deferModalOk" ref="deferModal"></defer-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DevMaintainceTaskModal from './modules/DevMaintainceTaskModal'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import TaskDeviceModal from './modules/TaskDeviceModal'
import MaintaincePlanCalendar from './MaintaincePlanCalendar.vue'
import DeferModal from './modules/DeferModal'
export default {
  name: 'DevMaintainceTaskList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    DevMaintainceTaskModal,
    TaskDeviceModal,
    MaintaincePlanCalendar,
    DeferModal
  },
  data() {
    return {
      description: '保养任务/记录管理页面',
      queryParam: {},
      // 表头
      columns: [
        {
          title: '任务单号',
          align: 'center',
          dataIndex: 'taskCode',
          width: 167
        },
        {
          title: '计划执行日期',
          align: 'center',
          dataIndex: 'planTime',
          customRender: function(text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
          sorter: true
        },
        {
          title: '实际执行时间',
          align: 'center',
          dataIndex: 'realTime',
          sorter: true
        },
        {
          title: '任务状态',
          align: 'center',
          dataIndex: 'taskStatus',
          //status
          scopedSlots: { customRender: 'status' },
          sorter: true
        },
        {
          title: '实际执行人',
          align: 'center',
          dataIndex: 'finishId',
          width: 167,
          scopedSlots: { customRender: 'finishId' }
        },
        {
          title: '保养设备',
          align: 'center',
          dataIndex: 'devId',
          scopedSlots: { customRender: 'device' }
        },
        {
          title: '任务详情',
          align: 'center',
          width: 187,
          dataIndex: 'list',

          customRender: (t, r) => {
            const result = t
              ?.map(item => {
                return item.maintenancePlace + '' + item.maintenanceOperate
              })
              .join('')
            return <j-ellipsis value={result} length={20} />
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 187,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/maintenance/devMaintainceTask/list',
        delete: '/maintenance/devMaintainceTask/delete',
        deleteBatch: '/maintenance/devMaintainceTask/deleteBatch',
        exportXlsUrl: '/maintenance/devMaintainceTask/exportXls',
        importExcelUrl: 'maintenance/devMaintainceTask/importExcel'
      },
      pageType: 'list',

      dictOptions: {},
      superFieldList: [],
      canEdit: true,
      isorter: {
        column: 'planTime',
        order: 'desc'
      }
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    pageTypeEumList() {
      return this.pageType === 'list'
    }
  },
  methods: {
    triggerBtn(val) {
      this.pageType = val
    },
    onDateChange: function(value, dateString) {
      this.queryParam.dplanTime_begin = dateString[0] + ' 00:00:00'
      this.queryParam.dplanTime_end = dateString[1] + ' 23:59:59'
    },
    initDictConfig() {},
    filterStatus(text, type) {
      return this.$filterDictTextByCache('maintaince_task_color', text)
    },
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'int', value: 'planId', text: '保养计划标识', dictCode: '' })
      fieldList.push({ type: 'string', value: 'taskCode', text: '任务单号', dictCode: '' })
      fieldList.push({ type: 'string', value: 'finishId', text: '任务完成人标识', dictCode: '' })
      fieldList.push({ type: 'string', value: 'finishName', text: '任务完成人名称', dictCode: '' })
      fieldList.push({ type: 'date', value: 'planTime', text: '计划执行时间' })
      fieldList.push({ type: 'date', value: 'realTime', text: '实际执行时间' })
      fieldList.push({ type: 'string', value: 'content', text: '养护过程', dictCode: '' })
      fieldList.push({ type: 'string', value: 'pictures', text: '附件', dictCode: '' })
      fieldList.push({ type: 'int', value: 'taskStatus', text: '任务状态(0待进行,1进行中,2已完成)', dictCode: '' })
      fieldList.push({ type: 'string', value: 'tenantId', text: '租户标识', dictCode: '' })
      fieldList.push({ type: 'string', value: 'orgId', text: '公司标识', dictCode: '' })
      this.superFieldList = fieldList
    },
    handleRecord(record) {
      this.$refs.taskDevice.edit(record)
      this.$refs.taskDevice.title = record.taskStatus !== 2 ? '保养记录回填清单' : '保养清单'
      this.canEdit = record.taskStatus !== 2
      this.$refs.taskDevice.disableSubmit = record.taskStatus == 2
    },
    handleAdd() {
      this.$refs.taskDevice.add()
      this.$refs.taskDevice.title = '保养记录新增'
      this.$refs.taskDevice.disableSubmit = false
    },
    // handleDetail: function (record) {
    //   this.$refs.taskDevice.edit(record)
    //   this.$refs.taskDevice.title = '详情'
    //   this.$refs.taskDevice.disableSubmit = true
    // },
    handleDefer(record) {
      this.$refs.deferModal.edit(record)
      this.$refs.deferModal.title = '任务延期'
    },
    deferModalOk() {
      this.loadData()
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
